
import algoliasearch from 'algoliasearch/lite'

const algoliaClient = algoliasearch('6CXFQTPZG1', 'ee00dfb41ca6a3c3ebfb33a6876120b6')
const index = algoliaClient.initIndex('Pages')

export default {
  name: 'CardsAutoRecommend',

  props: {
    pageTitle: {
      type: String,
      required: true
    },
    currentUrl: {
      type: String,
      default: ''
    },
    // Evergreen/popular articles to show if Algolia has no relevant results.
    // Pass these from the parent so they can differ per page/section.
    fallbackArticles: {
      type: Array,
      default () {
        return []
      }
    }
  },

  data() {
    return {
      articles: [],
      searchFailed: false
    }
  },

  computed: {
    // Falls back to the default articles if the search returned nothing usable
    displayArticles () {
      if (this.articles.length) {
        return this.articles
      }
      return this.fallbackArticles.slice(0, 3)
    }
  },

  async mounted() {
    try {
      const { hits } = await index.search(this.pageTitle, {
        hitsPerPage: 4
      })
      console.log('Algolia search results:', hits, this.currentUrl)
      
      this.articles = hits
        .filter(function (hit) {
          const hitSlug = hit.url.split('/').filter(Boolean).pop()
          return hitSlug !== this.currentUrl
        }.bind(this))
        .slice(0, 3)
    } catch (e) {
      // Swallow the error and let displayArticles fall back to fallbackArticles
      this.searchFailed = true
      console.error('[RelatedArticles] fetch failed:', e)
    }
  }
}
